import { Modal, Panel, Table } from '@/components/Bicester';
import { Cell } from '@/components/Bicester/Table';
import {
  DateTimeCell,
  OperationCell,
  PriceCell,
  ShoppingVillageCell,
} from '@/components/Bicester/Table/Cells';
import useRouter from '@/hooks/useRouter';
import useTable from '@/hooks/useTable';
import { fetchDeleteTicket, fetchReceiptList } from '@/services/account';
import { useRequest } from 'ahooks';
import _ from 'lodash';
import React, { useState } from 'react';
import { Alert } from 'rsuite';

const ReceiptRecord = ({ data }: { data: any }) => {
  const { match, query } = useRouter<{ id: string }>();

  const [deleteReceiptModal, setDeleteReceiptModal] = useState({
    id: null,
    show: false,
    content: '',
    confirm: '',
    onConfirm: null,
  });

  const {
    run: getReceiptList,
    data: { content_list: receiptListData, current_page, total } = {},
    loading: receiptListListLoading,
  } = useRequest(fetchReceiptList, {
    manual: true,
  });

  const { run: deleteTicket, loading: deleteTicketLoading } = useRequest(fetchDeleteTicket, {
    manual: true,
  });

  const { onChange, onSearch } = useTable(async (p) => {
    const params = Object.assign({}, p, {
      member_id: match.params.id,
    });
    await getReceiptList(params);
  });

  const handleHideModal = () => {
    setDeleteReceiptModal({
      ...deleteReceiptModal,
      id: null,
      show: false,
      onConfirm: null,
    });
  };

  return (
    <>
      <Panel
        title="小票记录"
        expanded
        defaultExpand={false}
        onExpand={(expanded) =>
          expanded &&
          !receiptListData?.length &&
          getReceiptList({ page: 1, member_id: match.params.id })
        }
        subTitle={`总计 ${total || 0} 条`}
      >
        <Table
          pageInfo={{ page: current_page, total }}
          data={receiptListData ?? []}
          loading={receiptListListLoading || deleteTicketLoading}
          columns={[
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '上传购物村',
              cell: <ShoppingVillageCell dataKey="shopping_village" />,
            },
            {
              columnProps: {
                flexGrow: 1.5,
              },
              header: '客户名',
              cell: <Cell>{data?.name}</Cell>,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '上传时间',
              cell: <DateTimeCell dataKey="create_at" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '消费日期',
              cell: <DateTimeCell dataKey="consume_time" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '消费品牌',
              cell: <Cell dataKey="brand" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '消费金额',
              cell: <PriceCell dataKey="price" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '上传人',
              cell: <Cell dataKey="type" />,
            },
            {
              columnProps: {
                flexGrow: 1,
              },
              header: '操作',
              cell: (
                <OperationCell
                  operation="DELETE"
                  onClick={(rowData) => {
                    const { id } = rowData;
                    setDeleteReceiptModal({
                      id,
                      show: true,
                      content: '是否删除该条记录？',
                      confirm: '删除',
                      onConfirm: () => {
                        deleteTicket(id).then((res) => {
                          if (_.isString(res)) {
                            Alert.success(res);
                            getReceiptList({
                              member_id: match.params.id,
                              page: 1,
                            });
                          }
                        });
                        handleHideModal();
                      },
                    });
                  }}
                />
              ),
            },
          ]}
          onChange={onChange}
        >
          <Table.Body isEmptyHoverBody={false} />
          <Table.Pagination />
        </Table>
      </Panel>
      <Modal
        show={deleteReceiptModal.show}
        content={deleteReceiptModal.content}
        confirm={deleteReceiptModal.confirm}
        onCancel={handleHideModal}
        onConfirm={deleteReceiptModal.onConfirm}
      />
    </>
  );
};

export default ReceiptRecord;
